import {
  createRouteRef,
  createExternalRouteRef,
} from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({ id: 'products' });
/** The catalog index, for the directory's "Components in catalog" link. */
export const catalogIndexRouteRef = createExternalRouteRef({
  id: 'products.catalog-index',
  optional: true,
});
